import {
  CustomerContextAttributes,
  DeliveryAttributes,
  InvoiceAccountNoteViewAttributes,
  OrderAttributes,
  PaymentAttributes,
} from 'api-client'

import { formatDateString } from '../utils/misc'

export const transformInvoice = (invoice: Invoice) => ({
  ...invoice,
  formattedDueDate: formatDateString(invoice.dueDate),
  formattedIssueDate: formatDateString(invoice.issueDate),
})

export type TransformedInvoice = ReturnType<typeof transformInvoice>
export type TransformedListInvoice = TransformedInvoice & {
  pdfUrl?: string
}

export interface Id {
  id: string
}

export interface Invoice extends InvoiceAccountNoteViewAttributes {
  delivery?: DeliveryAttributes &
    Id & {
      order?: OrderAttributes &
        Id & { customerContext: CustomerContextAttributes & Id }
    }
  id: string
  payment?: PaymentAttributes & Id
}
